import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

const icon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const cities = [
  { name: "Mumbai", lat: 19.076, lng: 72.8777 },
  { name: "Pune", lat: 18.5204, lng: 73.8567 },
  { name: "Nashik", lat: 19.9975, lng: 73.7898 },
  { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
  { name: "Aurangabad", lat: 19.8762, lng: 75.3433 },
  { name: "Kolhapur", lat: 16.705, lng: 74.2433 },
  { name: "Solapur", lat: 17.6599, lng: 75.9064 },
  { name: "Satara", lat: 17.6805, lng: 74.0183 },
  { name: "Sangli", lat: 16.8524, lng: 74.5815 },
  { name: "Ratnagiri", lat: 16.9902, lng: 73.3120 },
  { name: "Latur", lat: 18.4088, lng: 76.5604 },
  { name: "Jalgaon", lat: 21.0077, lng: 75.5626 },
  { name: "Ahilyanagar", lat: 19.0948, lng: 74.7480 },
  { name: "Dhule", lat: 20.9042, lng: 74.7749 },
  { name: "Nanded", lat: 19.1383, lng: 77.3210 },
  { name: "Akola", lat: 20.7002, lng: 77.0082 },
  { name: "Amravati", lat: 20.9374, lng: 77.7796 },
  { name: "Chandrapur", lat: 19.9615, lng: 79.2961 },
  { name: "Beed", lat: 18.9892, lng: 75.7601 },
];

const Ournetworkmap = () => {
  return (
    <div className="map-page">

      {/* HEADER */}
      <div className="map-header">
        <p>We provide cab service across all major cities in Maharashtra</p>
      </div>

      {/* MAP */}
      <div className="map-box">
        <MapContainer
          center={[19.5, 75.0]} // Maharashtra center
          zoom={6}
          style={{ height: "600px", width: "100%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {cities.map((city, index) => (
            <Marker
              key={index}
              position={[city.lat, city.lng]}
              icon={icon}
            >
              <Popup>
                🚖 <b>{city.name}</b> <br />
                Available Cab Service
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>

    </div>
  );
};

export default Ournetworkmap;